import styled from 'styled-components'

export const StyledButton = styled.button`
  width: ${({ $w }) => ($w === 'auto' ? 'auto' : $w ? `${$w}px` : '100%')};
  height: ${({ $h }) => ($h ? `${$h}px` : `45px`)};
  padding: ${({ $p }) => ($p ? `${$p}px` : `10px`)};

  background-color: ${({ $color }) => ($color ? $color : '#06357a')};
  color: #fff;
  border: 0;

  border-radius: 20px;
  transition: filter 0.7s;

  display: flex;
  align-items: center;
  justify-content: ${({ $alignX }) =>
    $alignX === 'left'
      ? 'flex-start'
      : $alignX === 'right'
        ? 'flex-end'
        : 'center'};
  gap: 10px;

  &:hover {
    background: ${({ $color }) => ($color ? $color : '#06357a')};
  }

  &:disabled {
    cursor: not-allowed;
    filter: brightness(0.7);
  }
`
